import { Typography } from '@mui/material';
import { useChatbotRegistration } from '../ai/ChatbotMgrContext';
import { KrCard } from '../card/KrCard';
import { useDashboardData } from './DashboardDataContext';

/**
 * A compact card showing one labeled, preformatted value, e.g. "Net Sales" and "$15.3B"
 *
 * With a description, it registers itself to the Chatbot using the data of the DashboardDataProvider it is in.
 */
export const StatCard = ({ label, value, description }) => {
  const { dataFetchParams } = useDashboardData();
  useChatbotRegistration(label, description, dataFetchParams);

  return (
    <KrCard minHeight={0} fill>
      <Typography variant="subtitle2" sx={{ mb: 0.5, color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </Typography>
    </KrCard>
  );
};
